import { State } from 'xstate';

import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
  ProductBuilderMachineStateSchema,
} from '../types';
import {
  getCurrentVariant,
  getCurrentVariantRollerNight,
} from './getCurrentVariant';

const imageBase =
  process.env.NODE_ENV === 'development'
    ? '/images'
    : process.env.REACT_APP_IMAGE_BASE;

type GetPatternImages = (
  state: State<
    ProductBuilderMachineContext,
    ProductBuilderMachineEvent,
    ProductBuilderMachineStateSchema
  >,
) => string;

export const getPatternImages: GetPatternImages = state => {
  const currentVariant = getCurrentVariant(state.context);
  let patternUrl = '';
  if (
    currentVariant &&
    currentVariant.featured_image &&
    currentVariant.featured_image.src
  ) {
    patternUrl = currentVariant.featured_image.src;
  }

  return patternUrl || `${imageBase}/Fiji-F0822-Pure-White.jpg`;
};

export const getRollerDayNightPatternImages: GetPatternImages = state => {
  const currentVariant = getCurrentVariantRollerNight(state.context);
  let patternUrl = '';
  if (
    currentVariant &&
    currentVariant.featured_image &&
    currentVariant.featured_image.src
  ) {
    patternUrl = currentVariant.featured_image.src;
  }

  return patternUrl || `${imageBase}/Fiji-F0822-Pure-White.jpg`;
};
